export default __webpack_public_path__ + "static/media/Letters2_07.7af4bd47.png";